import { WorkerScoringPanel } from '../../scoring/index.js'
import { useOperatorWorkerDetailHooks } from './workerDetailHooks.js'

/** The operator's worker panel: the shared scoring panel over the operator app's own reads, under the row's Scoring tab, which already names it; the worker's notes are the row's Messages tab. */
export function WorkerDetailPanel({ workerId }: { workerId: string | null }) {
  const hooks = useOperatorWorkerDetailHooks()
  return <WorkerScoringPanel workerId={workerId} hooks={hooks} showHeading={false} showBarriers={false} />
}
